import axios from 'axios';
import {LOGIN_SUCCESS,LOGIN_FAIL,LOGOUT,USER_LOADED,AUTH_ERROR,CLEAR_ERRORS,MAIL_OK,MAIL_NOTOK,CLEAR_MAILERROR,PW_UPDATED,PW_ERROR,ROBOT_CHECKED,CODE_OK,CODE_ERR,RETRY_FAIL} from './authTypes';


const initialState = {
  token: null,
  mailToken: null,
  userid: null,
  loading: true,
  isAuthenticated: null,
  error: null,
  validMail: false,
  mailError: null,
  robot: true,
  passwdUpdated: false,
  passwdError: null,
  codeVerified: null
};

export default (state=initialState, action) => {
  switch(action.type){
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        userid: action.payload,
        error: null,
        robot: false
      };
    case LOGIN_SUCCESS:
      axios.defaults.headers.common['x-auth-token']=action.payload.token;
      return {
        ...state,
        ...action.payload,
        token: action.payload.token,
        loading: false,
        isAuthenticated: true,
        error: null
      };
    case LOGIN_FAIL:
    case AUTH_ERROR:
      delete axios.defaults.headers.common['x-auth-token'];
      return {
        ...state,
        token: null,
        loading: false,
        isAuthenticated: false,
        error: action.payload,
        codeVerified: null
      };
    case RETRY_FAIL:
      return {
        ...state,
        userid: null,
        mailToken: null,
        validMail: false
      };
    case LOGOUT:
      delete axios.defaults.headers.common['x-auth-token'];
      return {
        ...state,
        token: null,
        mailToken: null,
        userid: null,
        loading: true,
        isAuthenticated: false,
        error: null,
        validMail: false,
        passwdUpdated: false,
        passwdError: null,
        codeVerified: null
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
        codeVerified: null
      };
    case CLEAR_MAILERROR:
      return {
        ...state,
        mailError: null
      };
    case MAIL_OK:
      return {
        ...state,
        ...action.payload,   //{mailToken,userid}
        //userid: action.payload,
        validMail: true,
        mailError: null
      };
    case MAIL_NOTOK:
      return {
        ...state,
        validMail: false,
        userid: null,
        mailError: action.payload
      };
    case ROBOT_CHECKED:
      return {
        ...state,
        robot: false
      };
    case PW_UPDATED:
      return {
        ...state,
        passwdUpdated: true
      };
    case PW_ERROR:
      return {
        ...state,
        passwdUpdated: false,
        passwdError: action.payload
      };
    case CODE_OK:
      return {
        ...state,
        codeVerified: true
      };
    case CODE_ERR:
      return {
        ...state,
        codeVerified: false
      };
    default:
      return {...state}
  }
};
